module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertoc01",
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertoc01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "epub:type": "pagebreak",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vii",
      "epub:type": "pagebreak",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chielliottdemocracy0007#ch01"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("1.")]), _vm._v("  The Demands of Democratic Citizenship")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chielliottdemocracy0008#pt01"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("I:")]), _vm._v("  How Much Democratic Citizenship?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chielliottdemocracy0009#ch02"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.")]), _vm._v("  Democracy’s Floor: The Case against Apathy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chielliottdemocracy0010#ch03"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("3.")]), _vm._v("  When Does Democracy Ask Too Much? Realism and the Paradox of Empowerment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chielliottdemocracy0011#ch04"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("4.")]), _vm._v("  The Citizen Minimum: Inclusion and Stand-By Citizenship")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chielliottdemocracy0012#pt02"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("II:")]), _vm._v("  Democratic Institutions for Busy People")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chielliottdemocracy0013#ch05"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("5.")]), _vm._v("  How to Democratize Elections: Annual Elections and Mandatory Voting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chielliottdemocracy0014#ch06"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("6.")]), _vm._v("  Engines of Inclusion: Political Parties in Competition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chielliottdemocracy0015#ch07"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("7.")]), _vm._v("  Putting Deliberation and Sortition in Their Place")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chielliottdemocracy0016#conc"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CONCLUSION:")]), _vm._v(" Too Much Democracy? 203")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chielliottdemocracy0017#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chielliottdemocracy0018#app"
    }
  }, [_vm._v("Appendix")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chielliottdemocracy0019#refs"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chielliottdemocracy0020#index"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chielliottdemocracy0021#fn_notes"
    }
  }, [_vm._v("Footnotes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2353aa9f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-elliott-democracy-0006.vue
// module id = 69
// module chunks = 0